/*
 * @Author: your name
 * @Date: 2021-07-05 20:45:48
 * @LastEditTime: 2021-07-12 11:53:54
 * @LastEditors: 李才人
 * @Description: In User Settings Edit
 * @FilePath: \m_saas_business_admin\src\utils\httpUtil\impl\HttpConfig.ts
 */
import { getToken, logoutRemove, getTokenNew, getComtyIdToken, logoutRemoveNew } from "@utils/userStorage";
import { Message, MessageBox } from "element-ui";
import store from "../../../store";
let MessageBoxRoom = null;
const config = {
  requestInterceptor: config => {
    // do something before request is sent
    // console.log("requestInterceptor", config);
    // if (config.url.indexOf("middleoos") > 0) {
    //   const urls: any = config.url.split("8080");
    //   config.url = "http://localhost:8082" + urls[1];
    // }
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
    }
    const version = store.state.version;
    let token = "";
    let communityToken = "";
    if (version === "v1") {
      token = getToken();
    } else if (version === "v2") {
      token = getTokenNew();
    }
    communityToken = getComtyIdToken() || "";
    // console.log("process.env.NODE_ENV", process.env.NODE_ENV, process.env.VUE_APP_IP);
    // const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2MTU4NjA3MjIwMDYsInBheWxvYWQiOiJcIjEzODIzNzA2NjE0XCIifQ.P3OPD0adR6epAgE258FTwe4QXbrrJKhsFuEKblKKPkE";
    // 各环境统一使用业务端 token，避免无差异分支依赖 NODE_ENV
    config.headers["Authorization"] = "Bearer business=" + token;
    config.headers["communityToken"] = communityToken;
    config.headers["token"] = token;
    config.headers["oss-auth-token"] = "GQSTSVB6uNnrWqtzPL7xNmWrwsxDJFDybwkaSfyua7L5";
    config.headers["Cache-Control"] = "no-cache";
    return config;
  },
  responseInterceptor: res => {
    if (res.code === 401) {
      console.error("error", res);
      const version = store.state.version;
      if (version === "v2") {
        logoutRemoveNew();
        // MessageBox.alert("您的账号登录状态已过期，请重新登录", "登录失效", {
        if (!MessageBoxRoom) {
          MessageBoxRoom = MessageBox.alert(res.message, "登录失效", {
            confirmButtonText: "确定",
            showClose: false,
            callback: () => {
              MessageBoxRoom = null;
              if (window.location.pathname != "/newCommunity/login") {
                window.location.replace("/newCommunity/login");
              }
            }
          });
        }
      } else {
        logoutRemove();
        // MessageBox.alert("您的账号登录状态已过期，请重新登录", "登录失效", {
        if (!MessageBoxRoom) {
          MessageBoxRoom = MessageBox.alert(res.message, "登录失效", {
            confirmButtonText: "确定",
            showClose: false,
            callback: () => {
              MessageBoxRoom = null;
              if (window.location.pathname != "/login") {
                window.location.replace("/login");
              }
            }
          });
        }
      }
      return true;
    }
    if (res.code === 5908056) {
      if (!MessageBoxRoom) {
        MessageBoxRoom = MessageBox.alert("你已切换到其他社区，需要刷新后才能继续操作。", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          callback: () => {
            MessageBoxRoom = null;
            if (window.location.pathname != "/newCommunity/communityList") {
              window.location.replace("/newCommunity/communityList");
            }
          }
        });
      }
      return true;
    }
    return false;
  },
  errorHandler: res => {
    Message.error(res.message);
  },
  baseURL: process.env.VUE_APP_API,
  timeout: 120000,
  withCredentials: false,
  ErrorArray: [{
    code: 9010100,
    msg: "用户不存在"
  }, {
    code: 9010101,
    msg: "密码错误"
  }, {
    code: 9010102,
    msg: "登出失败，预留错误码"
  }, {
    code: 9010103,
    msg: "手机号已存在"
  }, {
    code: 9010104,
    msg: "邮箱已存在"
  }, {
    code: 9010200,
    msg: "部门不存在"
  }, {
    code: 9010400,
    msg: "角色不存在"
  }, {
    code: 403,
    msg: "没有权限"
  }, {
    code: 404,
    msg: "找不到页面或接口"
  }, {
    code: 500,
    msg: "服务器被带走了！"
  },
  // { code: 53021034, msg: "该手机号已绑定其他机构，暂时无法创建团队!" },
  {
    code: 20107,
    msg: "请求参数异常！"
  }, {
    code: 400,
    msg: "请求参数出错！"
  }, {
    code: 9010200,
    msg: "部门不存在"
  }, {
    code: 9010201,
    msg: "当前移动部门不是最新，重新请求后再移动"
  }, {
    code: 9010201,
    msg: "部门人数不为 0 ，无法删除"
  }, {
    code: 20139,
    msg: "该手机已存在，请更换",
    necessary: true
  }, {
    code: 5908056,
    msg: "访问社区权限不足"
  }]
};
export default config;